import classNames from 'classnames'
import React from 'react'
import { ClassValue } from 'classnames/types'

interface CardHeaderProps {
    title?: any
    component?: any
    children?: any
    minimal?: boolean
    className?: ClassValue
    style?: object
}

export const CardHeader = ({
    title,
    component = null,
    children = null,
    minimal = false,
    className,
    style,
}: CardHeaderProps) => {
    return (
        <div
            className={classNames('bp4-card-header px-4', { minimal: minimal }, className)}
            style={style}
        >
            <span className="text-lg">{title}</span>
            {component && <span>{component}</span>}
            {children && <span>{children}</span>}
        </div>
    )
}
